$(function(){
   
    setupTabsWithHashes();
    showTabByHash();

    // $(window).on('hashchange', function(e) {
    //     showTabByHash();
    // });

})

function setupTabsWithHashes() {

    // store the currently selected tab in the hash value
    $(".nav-tabs a").on("shown.bs.tab", function(e) {
        var id = $(e.target).attr("href").substr(1);
        window.location.hash = "#tab-" + id;
        setCookie('lastTab', id, 24*60*60);

        showTabByHash();
    });

    $('.tab-content > div').each(function() {
        var id = $(this).attr('id');
        $('form', this).each(function() {
            var formAction = $(this).attr('action');
            $(this).attr('action', formAction + '#tab-' + id);
        });
    });
}

function showTabByHash() {

    let hash = '#';

    if (window.location.hash) {
        hash = window.location.hash.replace('tab-', '');
    }
    else if(getCookie('lastTab') != null && $('.nav-tabs a[href="#' + getCookie('lastTab') + '"]').length > 0) {
        hash = '#' + getCookie('lastTab');
    }
    else if ($(".nav-tabs a").length > 0){

        if($(".nav-tabs a")[0] !== undefined) {
            hash = '#' + $(".nav-tabs a")[0].href.split("#")[1];
        }
    }

    if((hash === undefined || hash === '#') && $('.tab-pane').length > 0 ) {
        $($('.tab-pane')[0]).addClass('active')
    }


    history.pushState("", document.title, window.location.pathname + window.location.search);

    
    if (hash && hash != '#') 
    {
        if (typeof jQuery.ui !== 'undefined') {
            $('.nav-tabs a[href="' + hash + '"]').tab('show');
        }
    }
}
